module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("This book is dedicated to Sensei, Kyoshi William (Bill) Ratzlaff and the rest of the Ratzlaff Family, to grandmaster, Steve Warren, and all of the Wakidokai Clan, Sensei Joe Felke, and all who I have trained with over the years. Without your instruction in superior, high-quality martial arts, I would not be where I am today. Thank you!")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I also dedicate this book to LeAnne, a young teen who took her life after being bullied repeatedly, and to her and my friend, Jessica Hickman, as well as anyone else who has ever been bullied and/or abused.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0